<template>
<div id="ap_importadore" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs10>
                <base-material-card color="primary" icon="library_books" title="Padrón de Importadores - Exportadores" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <!-- (24-02-2021): Lourdes solicitó quitar la opción de exportar-->
                            <!--v-btn @click="generar_reporte_sqs()" fab dark x-small color="success" title="Exportar Registros" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                            </v-btn-->
                            <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="datos.camposLayout" :exportFields="datos.encabezadoLayout" name="Layout ImpoExpo.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>
                        &nbsp;
                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" @click.native="modal=false" > cancel
                                        </v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>
                                                {{ update ? "Actualizar" : "Nuevo" }} Importador-Exportador
                                            </strong>
                                        </span>
                                    </v-card>                                    
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-row>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-text-field label="RFC" type="text" v-model="model.rfc" @input="model.rfc = model.rfc.toUpperCase()" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="8" md="8" lg="8" >
                                                    <v-text-field label="Nombre o Razón Social" type="text" v-model="model.nombre" maxlength="350" :rules="[rules.required]" ></v-text-field>
                                                </v-col>                                                
                                            </v-row>
                                            <v-row>                                                
                                                <v-col xs="12" sm="12" md="12" lg="12" >
                                                    <v-text-field label="Fuente" type="text"  v-model="model.fuente" maxlength="250" ></v-text-field>
                                                </v-col>                                                
                                            </v-row>
                                            <v-row>                                                
                                                <v-col xs="12" sm="12" md="12" lg="12" >
                                                    <v-text-field label="Texto1 - Otra información" type="text"  v-model="model.texto1" maxlength="250" ></v-text-field>
                                                </v-col>                                                
                                            </v-row>
                                            <v-row>                                                
                                                <v-col xs="12" sm="12" md="12" lg="12" >
                                                    <v-text-field label="Texto2 - Otra información" type="text"  v-model="model.texto2" maxlength="250" ></v-text-field>
                                                </v-col>                                                
                                            </v-row>                                                                                
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon>Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>   
                        <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()" >                   
                            <v-client-table ref="principalTable" :data="datos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_importador_exportador)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_importador_exportador)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>                                
                            </v-client-table>    
                            <template>
                                <div v-if="pwPagination.total > 0" >
                                    <div class="mt-3" >
                                        <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="datos" :options="pwPagination.options" ></PaginacionComponent>
                                    </div>
                                </div>
                            </template>   
                            Se muestran máximo los 20 primeros registros que coincidan con los filtros ingresados
                            <br>TOTAL DE REGISTROS EN CATALOGO: {{total_registros}}
                        </div>                 
                    </v-card-text>
                </base-material-card>
            </v-flex>

        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";
import PaginacionComponent from '@/components/PaginacionComponent.vue';

export default {
    components: {
        "v-menu-lateral-apendice": menuLateral,
        "v-power-titulo": powerTitulo,
        "PaginacionComponent": PaginacionComponent
    },
    mounted() {},

    data: () => ({
        url_active: location.href,        
        editable: true,             
        title: "Padrón Importadores-Exportadores",        
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apéndices",
                disabled: true,
                to: ""
            }
        ],   
        model_filters: '',
        pwPagination: {
            total: 0,
            links: {
                url: '',
                next: '',
                prev: '',
            },
            options: {
                tipo: 1,
                size: 10,                
                filters: {}
            }
        },     
        columns: [            
            "rfc",
            "nombre",
            "fecha",
            "texto1",
            "texto2",
            "actions"
        ],
        options: {                  
            headings: {
                "rfc":"RFC",
                "nombre":"Nombre o Razón Social", 
                "fecha":"Fecha Actualización",
                "texto1":"Texto1",
                "texto2":"Texto2",
                actions: "Operaciones"
            },     
            filterAlgorithm: {
                rfc: function() {return true;},
                nombre: function() {return true;}
            },       
        },
        URL: "",
        
        loading: false,
        modal: false,
        update: false,        
        model: {
            id_importador_exportador: 0,
            rfc:"",
            nombre:"",
            fecha:"",
            fuente:"",
            texto1:"",
            texto2:"",            
        },
        rules: {
            required: v => !!v || "Este campo es requerido",            
        },
        total_registros: 0,
        datos: {
            selected: [],
            camposexcel: {
                RFC: "rfc",
                "Nombre o Razón Social":"nombre",
                "Fecha de Actualización": "fecha",                
                "Fuente":"fuente",
                "Texto1":"texto1",
                "Texto2":"texto2"
            },
    
            items: [],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {                
                rfc: "rfc",
                nombre: "nombre",                
                fuente:"fuente",
                texto1:"texto1",
                texto2:"texto2",
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{                
                rfc: "[RFC Importador-Exportador]",
                nombre: "[Nombre o Razón Social]",                
                fuente: "[Fuente de la información]",
                texto1: "[Texto1 - otra información]",
                texto2: "[Texto2 - otra información]"
            }]
        },       
        camposObligatorios: {
            "rfc": "RFC",
            "nombre": "Nombre o Razón Social",            
        },
        modelReporte: {
            rfc: "ADMINISTRACION",
            usuario: "", 
            reporte_url: "/reportes_ws/excel_padron_importadores/",
            nombre_reporte: "Padron Importadores",
            tipo: "Padron_ImpoExpo",
        },

    }),
    
    methods: {
        generar_reporte_sqs() {                               
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');            
            if (this.pwPagination.options.filters.filtros != undefined){
                this.modelReporte["filtros"] = this.pwPagination.options.filters.filtros;
            }
            
            axios({
                    method: "post",
                    url: this.$hostname + "reportes/save_reporte/",                                         
                    data: this.modelReporte,
                })
                .then(response => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se está generando. Recibirá una notificación con el enlace de descarga.",
                        footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    var titulo = "¡Operación no Permitida!";
                    var tipo = "error";
                    if (typeof error.response !== "undefined") {
                        mensaje = error.response.data.mensaje;
                        if (error.response.status == 406){
                            titulo = "¡Ya existe un reporte en proceso!";
                            tipo = "info";
                        }
                    } else {
                        mensaje = "Ocurrió un error al generar el reporte";
                    }
                    this.$swal({
                        type: tipo,
                        title: titulo,
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {                        
                    this.$root.$dialogLoader.hide();
                });
                           
            
        },
       
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();                
                this.update = false;
            } else {                
                this.update = true;
            }
            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }            
        },

        guardar() {            
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_importador_exportador + "/";
                }
                this.model["fecha"] = this.$moment().format("YYYY-MM-DD");
                const datos = this.model;
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        try {
                            var errores = "";
                            if (typeof error.response.data != "undefined") {
                                Object.keys(error.response.data).forEach(function (key) {
                                    for (var k in error.response.data[key]) {
                                        errores += key + ": " + error.response.data[key][k];
                                        errores += "<br>";
                                    }
                                });
                            }
                                
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos",
                                footer: errores,
                                //showConfirmButton: false,
                            });
                            //console.log(err);
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                        } catch (error) {
                            console.log(error);
                        }
                        
                    });
            }
        },
        
        cargar: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");            
                axios.post(this.$hostname+"catalogos/importadores_exportadores/get_data/")                                
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos.items = res.data.results;
                        this.pwPagination.total = res.data.count;
                        this.pwPagination.links.next = res.data.next;
                        this.pwPagination.links.prev = res.data.previous;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {                   
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
                axios.post(this.$hostname+"catalogos/importadores_exportadores/get_total/")                                                               
                .then(res => {
                    if (res.data != undefined) {
                        this.total_registros = res.data;                        
                    }
                })
                .catch(err => {
                    console.log(err);                    
                });
        },
       
        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;                    
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
                }
                    
            });
        }, //delete
        
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + key + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = "";
            
            try {
                for (var k in results) {
                    renglonesLeidos++;
                    results[k]["user_updated"] = thisObject.$local_storage.get("email");
                    results[k]["fecha"] = thisObject.$moment().format("YYYY-MM-DD");
                    var obligatorios = thisObject.verificaObligatorios(results[k]);
                    if (obligatorios !== true) {
                        errores++;
                        if (erroresText.indexOf(obligatorios) == -1)
                            erroresText += obligatorios;
                    } else {
                        if ( results[k]['rfc'].toString().length > 100 ){
                            errores++;
                            erroresText += "- RFC \"" + results[k]["rfc"] + "\" debe ser menor de 100 caracteres <br>";
                        } 

                    }                    
                    
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText +=
                        "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return {
                    errores: errores,
                    erroresText: erroresText
                };
            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
            }
            //}); //promise
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = "";            
            try {
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText
                    });
                    
                } else {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var resultadoFinal = [];
                    for (var k in results) {
                        
                        var aerolinea = {
                            rfc: results[k]["rfc"].toString().toUpperCase(),
                            nombre: results[k]["nombre"],
                            fuente: results[k]["fuente"],
                            fecha: results[k]["fecha"],
                            texto1: results[k]["texto1"],
                            texto2: results[k]["texto2"],
                            user_updated: results[k]["user_updated"]
                        };
                        resultadoFinal.push(aerolinea);
                    }
                    
                    axios
                        .post(this.URL + "importar_importadores/", resultadoFinal)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                    for (var i = 0; i < err.response.data.length; i++) {
                                        Object.keys(err.response.data[i]).forEach(function (key) {
                                            var errors = err.response.data[i][key];                                            
                                            //Este trae 2 niveles, por eso el campo queda en la key2
                                            Object.keys(errors).forEach(function (key2) {
                                                let pos = errores.indexOf(key + ": " + errors[key2]);
                                                if (pos < 0) {
                                                    errores += key + ": " + errors[key2];
                                                    errores += "<br>";
                                                }
                                            });                                             
                                        });
                                    }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();                            
                        });
                }
            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
                this.$root.$dialogLoader.hide();
            }
        },  

    }, //methods

    created: function () {
        this.URL = this.$hostname + "catalogos/importadores_exportadores/";    
        this.pwPagination.links.url = this.$hostname + "catalogos/importadores_exportadores/get_data/";        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.modelReporte.usuario = this.$local_storage.get("id_usuario");        
        
        if (this.$local_storage.get("id_cliente") > 0) {
            this.modelReporte.rfc = this.$local_storage.get("rfc");
            this.editable = false;
            delete this.options.headings["actions"];
            var key = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "actions") key = k;
            }
            if (key > 0) delete this.columns[key];
        }
        this.cargar();     
    },
    mounted: function() {        
        this.model_filters = this.$refs.principalTable.query;
    },
    watch: {
        model_filters: {
            handler(val) {
                this.pwPagination.options.filters = {
                    filtros: {
                        nombre__icontains: this.model_filters.nombre,
                        rfc__icontains: this.model_filters.rfc,
                        fecha__icontains: this.model_filters.fecha,
                        texto1__icontains: this.model_filters.texto1,
                        texto2__icontains: this.model_filters.texto2,
                    }
                }
            },
            deep: true
        }
    },
};
</script>